const List = () => import('./main.vue');

export default [
  {
    name: 'exportacao/remessa-cancelamento-adesao',
    path: '/exportacao/remessa-cancelamento-adesao',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Remessa Cancelamento Adesão',
      icon: 'boxes',
      can: 'list',
      on: 'remessacancelamentoadesao',
      bisneto: true,
      client: 'copass',
    },
  },
];
